__turbopack_context__.v({
  "heatApp": "wJ2kPa_heatApp",
  "selectButton": "wJ2kPa_selectButton",
  "selected": "wJ2kPa_selected",
});
